export default __webpack_public_path__ + "static/media/niit-logo.4985addf.png";